import { Component, OnInit, OnDestroy, DoCheck } from '@angular/core';
import { RightSideDrawerService } from '../right-side-drawer.service';
import { AssignActivitiesProjectsService } from '../../../survey-insight/survey-creation/assign-activities-projects/assign-activities-projects.service';
import { SessionService } from '../../session-service/session.service';
import { ToastrService, LoadingIndicatorService } from '@kpmg-tax/ui';
import { BaseResponse } from '../../models/base-response.model';
import { Messages } from '../../constants/messages';
import { SurveyPrepDataEntity, EngagementGroupProject } from '../../models/Survey-Creation/SurveyCreation.model';
import { ROUTE_URL } from '../../constants/route-constants';
import { Router } from '@angular/router';
import { SurveyListService } from 'src/app/survey-insight/survey-list/survey-list.service';
import { copyObject } from '../../lib/custom-tools';
import { LegalEntities } from '../../models/legal-entity/legal-entity.model';

@Component({
  selector: 'aa-add-projects',
  templateUrl: './add-projects-component.html',
  styleUrls: ['../aa-add-activities/add-activities-component.scss']
})
export class AddProjectsComponent implements OnInit, OnDestroy {
  projects: EngagementGroupProject[] = [];
  projectsOriginal: EngagementGroupProject[] = [];
  targetFormSubmitted = false;
  rowData: SurveyPrepDataEntity[] = [];
  selectedData: any;
  masterData: any;
  selectedProjects: EngagementGroupProject[] = [];
  engagementId: string;
  activeProjectIndex: number = null;
  selectAll = false;
  allGroupValue: string = null;
  isAddDisabled = false;
  drawName: string = '';
  entities:any[];
  defaultentity: string='';
  listEntities:LegalEntities[]
  constructor(private _surveyListService: SurveyListService,
    public rightSideDrawerService: RightSideDrawerService,
    public sessionService: SessionService,
    public _assignActivitiesProjectsService: AssignActivitiesProjectsService,
    public toastrService: ToastrService,
    private _loader: LoadingIndicatorService, private _router: Router) {
    this.engagementId = this.sessionService.getSession('engagementId');
  }

  ngOnInit() {
    this.masterData = this.rightSideDrawerService.singleRowEditData;
    this.rowData = this.masterData.rowData;
    let groupValueTitle: string;
    this.rowData.forEach((x: any) => {
      groupValueTitle = groupValueTitle ? groupValueTitle + ', ' + x.groupValue : x.groupValue;
    });
    this.allGroupValue = groupValueTitle;
    this.GetProjectList();
    if (!this.isAddDisabled) {
      this.GetDrawName();
      this.rightSideDrawerService.setMandatoryField(true, 'Assign Projects for ' + this.drawName);
    } else {
      this.rightSideDrawerService.setMandatoryField(false, '');
    }
    
  }

  navigateToProjectsAndAcrivities(): void {
    this.rightSideDrawerService.closeRightSideDrawer();
    this._router.navigate([ROUTE_URL.MANAGE_PROJECT(this.engagementId)]);
  }

  // ngDoCheck() {
  //   if (!this.isAddDisabled) {
  //     this.GetDrawName();
  //     this.rightSideDrawerService.setMandatoryField(true, 'Assign Projects for ' + this.drawName);
  //   } else {
  //     this.rightSideDrawerService.setMandatoryField(false, '');
  //   }
  // }
  GetDrawName() {
    let drawName = '';
    if (this.rowData[0].adHocName) { drawName = drawName + this.rowData[0].adHocName + ', '; }
    if (this.rowData[0].companyName) { drawName = drawName + this.rowData[0].companyName + ', '; }
    if (this.rowData[0].costCenterDescName) { drawName = drawName + this.rowData[0].costCenterDescName + ', '; }
    if (this.rowData[0].individualName) { drawName = drawName + this.rowData[0].individualName + ', '; }
    if (this.rowData[0].locationName) { drawName = drawName + this.rowData[0].locationName + ', '; }
    if (this.rowData[0].smeName) { drawName = drawName + this.rowData[0].smeName + ', '; }
    if (this.rowData[0].timeTrackingDataName) { drawName = drawName + this.rowData[0].timeTrackingDataName + ', '; }
    if (this.rowData[0].titleName) { drawName = drawName + this.rowData[0].titleName + ', '; }
    if (this.rowData[0].taxPeriodName) { drawName = drawName + this.rowData[0].taxPeriodName + ', '; }
    if (drawName.length >= 0) {
      drawName = drawName.slice(0, -1);
    }
    this.drawName = this._surveyListService.removeUnwantedCharcterAtEnd(drawName.trim(), ',');
    let surveyName = '';
    if (this.rowData[0].adHocValue) { surveyName = surveyName + this.rowData[0].adHocValue + ', '; }
    if (this.rowData[0].companyValue) { surveyName = surveyName + this.rowData[0].companyValue + ', '; }
    if (this.rowData[0].costCenterDescValue) { surveyName = surveyName + this.rowData[0].costCenterDescValue + ', '; }
    if (this.rowData[0].individualValue) { surveyName = surveyName + this.rowData[0].individualValue + ', '; }
    if (this.rowData[0].locationValue) { surveyName = surveyName + this.rowData[0].locationValue + ', '; }
    if (this.rowData[0].smeValue) { surveyName = surveyName + this.rowData[0].smeValue + ', '; }
    if (this.rowData[0].timeTrackingDataValue) { surveyName = surveyName + this.rowData[0].timeTrackingDataValue + ', '; }
    if (this.rowData[0].titleValue) { surveyName = surveyName + this.rowData[0].titleValue + ', '; }
    if (this.rowData[0].taxPeriodValue) { surveyName = surveyName + this.rowData[0].taxPeriodValue + ', '; }
    surveyName = this._surveyListService.removeUnwantedCharcterAtEnd(surveyName.trim(), ',');
    this.drawName = this.drawName.trim() + ': ' + surveyName.trim();
  }
  GetProjectList = () => {
    this._loader.display(true, true);
    this._assignActivitiesProjectsService.GetProjectsList(this.masterData.groupId, '').subscribe((data: BaseResponse) => {
      if (data !== null && data.success) {
        this._loader.display(false);
        this.entities=data.result.legalEntityProjectAssociations;       
        this.projects = data.result.engagementGroupProjects.sort((a, b) => a.projectName.localeCompare(b.projectName));
        this.listEntities=data.result.listofLegalentities;
        if (this.rowData.length === 1 && this.rowData[0].projects !== null) {
          this.UpdateProjectSelection(this.rowData[0].projects, this.projects);
        } else if (this.rowData.length > 1) {
          this.UpdateProjectSelectionMultiple();
        }
        this.selectedProjects = this.projects.filter(x => x.isSelected === true);
        if (this.projects.length === this.selectedProjects.length) {
          this.selectAll = true;
        }
        this.projectsOriginal = copyObject(this.projects);
        if(this.rowData.length==1 && this.rowData[0].companyValue !=null)
    {
      this.defaultentity=this.rowData[0].companyValue;
      this.searchDataTableFilter(this.rowData[0].companyValue);
    }
      } else {
        this.toastrService.setErrorMessage(
          Messages.SurveyCreation.AssignProjectActivities
            .GetProjectListFailure
        );
      }
      this._loader.display(false);
    });
  };

  UpdateProjectSelection(selectedProjects: EngagementGroupProject[], projectList: EngagementGroupProject[]) {
    selectedProjects.forEach(x => {
      projectList.map(prj => {
        if (prj.projectId != null && prj.projectId === x.projectId) {
          prj.isSelected = true;
        }
      });
    }
    );
  }

  UpdateProjectSelectionMultiple() {
    const allProjects: EngagementGroupProject[] = [];
    const rowDataCount: number = this.rowData.length;
    this.rowData.forEach(x => {
      if (x.projects != null) {
        allProjects.push(...(x.projects));
      }
    });
    this.projects.forEach(x => {
      const prjCount: number = allProjects.filter(prj => prj.projectId === x.projectId).length;
      if (prjCount === rowDataCount) {
        x.isSelected = true;
        x.indeterminate = false;
      } else if (prjCount > 0 && prjCount < rowDataCount) {
        x.isSelected = false;
        x.indeterminate = true;
      } else {
        x.isSelected = false;
        x.indeterminate = false;
      }
    });
  }

  SubmitProjects = () => {
    this.isAddDisabled = true;
    if (this.projects.length !== 0 && this.selectedProjects.length !== 0) {
      if (this.rowData.length === 1) {
        this.rowData.forEach(x => {
          x.projects = this.selectedProjects;
        });
      }
      else {
        this._loader.display(true, true);
        const indeterminatePrj: EngagementGroupProject[] = this.projects.filter(x => x.indeterminate);
        this.rowData.forEach(x => {
          let indeterminateOriginalPrj: EngagementGroupProject[] = [];
          if (x.projects != null) {
            indeterminateOriginalPrj = x.projects;
          }
          const indeterminateCalculatedPrj: EngagementGroupProject[] = [];
          indeterminatePrj.forEach(x => {
            indeterminateCalculatedPrj.push(...indeterminateOriginalPrj.filter(itm => itm.projectId === x.projectId));
          });
          x.projects = [];
          x.projects.push(...indeterminateCalculatedPrj);
          x.projects.push(...this.selectedProjects);
        });
        this._loader.display(false);
      }
      this.toastrService.setSuccessMessage(
        Messages.SurveyCreation.AssignProjectActivities
          .AddProjectToTempSuccess
      );
    }
    this.rightSideDrawerService.closeRightSideDrawer();
  };

  SetProjects = (project, event, index) => {
    if (event.target.checked) {
      project.isSelected = true;
      if (this.selectedProjects.filter(x => x.projectId === project.projectId).length === 0) {
        this.selectedProjects.push(project);
      }
      if (this.projects.length === this.selectedProjects.length) {
        this.selectAll = true;
      }
      this.updateProject(project.projectId, true);
    } else {
      this.selectAll = false;
      project.isSelected = false;
      this.isAddDisabled = true;
      this.selectedProjects = [...this.selectedProjects.filter(x => x.projectId !== project.projectId)];
      this.updateProject(project.projectId, false);
    }
    project.indeterminate = false;

    if (this.selectedProjects.length === 0) {
      this.isAddDisabled = true;
    } else {
      this.isAddDisabled = false;
    }
  };

  SelectAll = event => {
    if (event.target.checked) {
      this.selectAll = true;
      this.isAddDisabled = false;
      this.updateAllProjects(true, false);
    } else {
      this.isAddDisabled = true;
      this.updateAllProjects(false, false);
    }
  };

  updateAllProjects(isSelected:boolean, inDeterminate:boolean){    
    this.projects.forEach((x: any) => {
      x.isSelected = isSelected;
      x.indeterminate = inDeterminate;
      let item = this.projectsOriginal.find(item => item.projectId === x.projectId);
      if(item) {      
        item.isSelected = isSelected;  
        item.indeterminate = inDeterminate;   
      } 
    });
    this.selectedProjects = this.projectsOriginal.filter(x => x.isSelected || x.indeterminate);
  }

  updateProject(projectId:number, isSelected:boolean){

    let item = this.projectsOriginal.find(item => item.projectId === projectId);
    if(item) {      
      item.isSelected = isSelected;     
    } 
  }

  ngOnDestroy() {
    this.rightSideDrawerService.closeRightSideDrawer();
  }

  searchDataTableFilter(searchText: string) {
    let listOfProjects:EngagementGroupProject[] = copyObject(this.projectsOriginal);
   let listofEntities=copyObject(this.entities);
    this.projects = listOfProjects?.filter(x => x.projectName.toLowerCase().
    indexOf(searchText.toLowerCase()) !== -1);
 let filtered=listofEntities?.filter(x=>x.legalEntityName.toLowerCase().
    indexOf(searchText.toLowerCase()) !== -1)
    let projects=filtered?.map(x=>x.projects)
    
    let newarrayofids=[];
    let entityinprojects=[]
    for(var i = 0; i < projects.length; i++){
      for(var j = 0; j < projects[i].length; j++){
  
        newarrayofids.push(projects[i][j]?.projectId);
      }
      //push back to this.projects
       entityinprojects=listOfProjects.filter(item => newarrayofids.indexOf(item.projectId) != -1);
      
       

  }
  if(this.listEntities.length>0)
  {
    let checkinlist=this.listEntities?.filter(x=>x.legalEntityName.toLowerCase().
    indexOf(searchText.toLowerCase()) !== -1)
    if(checkinlist.length>0)
    {
    let globalprjt=listOfProjects.filter(x=>x.isGlobal==true);
    entityinprojects.push(...globalprjt);
    }
  }
  this.projects.push(...entityinprojects)
  this.projects=Array.from(new Set(this.projects.map((item: any) => item)));
  this.projects=this.projects.sort((a, b) => a.projectName.localeCompare(b.projectName));



  }

  resetDataTableFilter(searchText: string) {
    (<HTMLInputElement>document.getElementById("searchtext")).value = '';
    let listOfProjects:EngagementGroupProject[] = copyObject(this.projectsOriginal);
    this.projects = listOfProjects?.filter(x => x.projectName.toLowerCase().indexOf(searchText.toLowerCase()) !== -1);
    if (this.projects.length !== this.selectedProjects.length) {
      this.selectAll = false;
    }
  }

  getSelectedProjectsCount() {
    return this.projects?.filter(x => x.isSelected || x.indeterminate).length;
  }
}
